const LoggedInLayout = () => import("../../views/LoggedInLayout.vue");
const AllApps = r => require.ensure([], () => r(require('./views/UserApps.vue')));
const UserApps = r => require.ensure([], () => r(require('./views/allapps.vue')));
const changepwd = r => require.ensure([], () => r(require('./views/changepwd.vue')));

const moduleRoute = {
  path: "/",
  component: LoggedInLayout,
  children: [
    
    {
      path: "/appview",
      component: UserApps
    },
    {
      path: "/allapps",
      component: AllApps
    },
    //changepwd
    {
      path: "/changepwd",
      component: changepwd
    }
  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
